/* slp-bundles (17 Oct 2026): native bundle picker for the pdp24 product page, replacing Kaching.
   Markup + data: snippets/slp-bundles.liquid. Deals: tools/bundles_config.py (real Shopify automatic discounts).
   "Just this one" leaves the theme's own add flow alone. A set card takes over the form submit, checks every extra
   piece has a size, and adds everything in ONE /cart/add.js call, then opens the theme's mini cart. */
(function () {
  'use strict';
  var root = document.getElementById('slpBundles');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var form = root.closest('form');
  if (!form) return;
  var cards = [].slice.call(root.querySelectorAll('.slp-b__card'));
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL'];

  var money = function (c) { var n = c / 100; return '$' + (n % 1 ? n.toFixed(2) : n.toFixed(0)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var isSize = function (name) { return /size/i.test(name); };

  // ---- main product: read whatever the theme's own picker has set ----
  var mainData = (function () {
    var out = {};
    [].slice.call(form.querySelectorAll('[data-product-select] [value]')).forEach(function (el) {
      var t = el.querySelector('.price-to-load'), raw = t ? t.textContent : '';
      var m = raw.replace(/,/g, '').match(/\$([\d.]+)\s*$/);
      out[el.getAttribute('value')] = { price: m ? Math.round(parseFloat(m[1]) * 100) : 0, name: (el.firstChild && el.firstChild.textContent || '').trim(), ok: !el.hasAttribute('disabled') };
    });
    return out;
  })();
  function mainVariant() {
    var idEl = form.querySelector('input[name="id"]');
    var id = idEl ? idEl.value : '';
    return { id: +id, info: mainData[id] || { price: 0, name: '', ok: true } };
  }

  // ---- partner pieces ----
  var picks = []; // one per partner block: { el, data, sel: {optionIndex: value} }
  cards.forEach(function (card) {
    card.partners = [].slice.call(card.querySelectorAll('[data-partner]')).map(function (el) {
      var data = JSON.parse(el.querySelector('script').textContent);
      var p = { el: el, card: card, data: data, sel: {} };
      if (data.choices) { // matching set: the second pair can be any print; start on the shopper's own print
        var live = function (c) { return c.variants.some(function (v) { return v.a; }); };
        var cs = data.choices, want = el.dataset.partner;
        p.choices = cs; p.mainKey = data.mainKey; p.line = card.querySelector('.slp-b__line');
        p.both = /Both for/.test(p.line.textContent);
        p.idx = cs.findIndex(function (c) { return c.key === data.mainKey && live(c); });
        if (p.idx < 0) p.idx = cs.findIndex(function (c) { return c.handle === want && live(c); });
        if (p.idx < 0) p.idx = cs.findIndex(live);
        p.data = data = cs[p.idx];
        var im = card.querySelector('[data-thumb="0"]'); if (im && data.img) im.src = data.img;
      }
      // options that are not a size get their first in-stock value picked for the shopper; sizes never are
      data.options.forEach(function (name, i) {
        if (isSize(name)) return;
        var v = data.variants.filter(function (x) { return x.a; })[0];
        if (v) p.sel[i] = v.o[i];
      });
      picks.push(p);
      return p;
    });
  });
  function valuesOf(p, i) {
    var seen = {}, vals = [];
    p.data.variants.forEach(function (v) { if (!seen[v.o[i]]) { seen[v.o[i]] = 1; vals.push(v.o[i]); } });
    if (isSize(p.data.options[i])) vals.sort(function (a, b) { return (SIZE_ORDER.indexOf(a) + 99) % 99 - (SIZE_ORDER.indexOf(b) + 99) % 99; });
    return vals;
  }
  function inStock(p, i, val) { // any in-stock variant with this value that fits the other picks
    return p.data.variants.some(function (v) {
      if (!v.a || v.o[i] !== val) return false;
      for (var k in p.sel) if (+k !== i && v.o[k] !== p.sel[k]) return false;
      return true;
    });
  }
  function chosen(p) {
    if (Object.keys(p.sel).length < p.data.options.length) return null;
    return p.data.variants.filter(function (v) { return v.a && v.o.every(function (o, i) { return p.sel[i] === o; }); })[0] || null;
  }
  function priceOf(p) {
    var v = chosen(p);
    if (v) return v.p;
    var ok = p.data.variants.filter(function (x) { return x.a; });
    return Math.min.apply(null, ok.map(function (x) { return x.p; }));
  }
  // "his pair" / "her tee" on matching sets, otherwise "the Pillow Talk Pant" (no "the The ...")
  function who(p) { return p.el.dataset.who || (/^the /i.test(p.data.title) ? p.data.title : 'the ' + p.data.title); }
  function choosePrint(p, idx) {
    var keep = p.sel;
    p.idx = idx; p.data = p.choices[idx]; p.sel = {};
    p.data.options.forEach(function (name, i) { if (keep[i] && inStock(p, i, keep[i])) p.sel[i] = keep[i]; }); // keep the size if that print has it
    var img = p.card.querySelector('[data-thumb="0"]');
    if (img && p.data.img) img.src = p.data.img;
  }
  function matchLine(p) {
    var c = p.choices[p.idx], same = c.key === p.mainKey;
    var t = 'Add ' + (p.el.dataset.who || 'the pair') + (same ? ' in the same print.' : ' in ' + c.label + '.');
    if (p.both) t += ' Both for ' + money(total(p.card).now) + '.';
    p.line.textContent = t;
  }
  function renderPick(p) {
    var html = '';
    if (p.choices) {
      html += '<span class="slp-b__label">Print for ' + esc(p.el.dataset.who || 'the pair') + ': <b>' + esc(p.choices[p.idx].label) + '</b></span>' +
        '<span class="slp-b__prints" role="radiogroup" aria-label="Print for ' + esc(p.el.dataset.who || 'the pair') + '">' +
        p.choices.map(function (c, i) {
          var ok = c.variants.some(function (v) { return v.a; });
          return '<button type="button" class="slp-b__print" role="radio" data-print="' + i + '" aria-checked="' + (i === p.idx) + '" aria-label="' + esc(c.label + (ok ? '' : ', sold out')) + '" title="' + esc(c.label) + '"' +
            (ok ? '' : ' disabled') + (c.bg ? ' style="background:' + esc(c.bg) + '"' : '') + '>' + (c.icon ? '<img src="' + esc(c.icon) + '" alt="" width="44" height="44" loading="lazy">' : '') + '</button>';
        }).join('') + '</span>';
      matchLine(p);
    }
    p.data.options.forEach(function (name, i) {
      var vals = valuesOf(p, i);
      if (vals.length < 2 && !isSize(name)) return;
      var need = isSize(name) && !p.sel[i];
      html += '<span class="slp-b__label' + (need && p.card.classList.contains('is-need') ? ' is-need' : '') + '">' +
        (isSize(name) ? (p.sel[i] ? 'Size for ' + esc(who(p)) + ': <b>' + esc(p.sel[i]) + '</b>' : 'Pick a size for <b>' + esc(who(p)) + '</b>')
                      : esc(name) + ': <b>' + esc(p.sel[i] || '') + '</b>') + '</span>' +
        '<span class="slp-b__sizes" role="group" aria-label="' + esc(name + ' for ' + who(p)) + '">' +
        vals.map(function (val) {
          var ok = inStock(p, i, val);
          return '<button type="button" class="slp-b__size" data-opt="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + (p.sel[i] === val) + '"' +
            (ok ? '' : ' disabled aria-label="' + esc(val) + ', sold out"') + '>' + esc(val) + '</button>';
        }).join('') + '</span>';
    });
    // keep the JSON script, replace the rest
    var script = p.el.querySelector('script');
    p.el.innerHTML = ''; p.el.appendChild(script);
    p.el.insertAdjacentHTML('beforeend', html);
  }

  // ---- prices on every card ----
  var current = 0;
  function selected() { return cards[current]; }
  function total(card) {
    var m = mainVariant().info.price, qty = +card.dataset.qty || 1;
    var full = m * qty;
    (card.partners || []).forEach(function (p) { full += priceOf(p); });
    return { full: full, now: full - (+card.dataset.save || 0) };
  }
  function render() {
    var mv = mainVariant();
    cards.forEach(function (card, i) {
      card.classList.toggle('is-on', i === current);
      var t = total(card), now = card.querySelector('[data-now]'), was = card.querySelector('[data-was]');
      if (now) now.textContent = money(t.now);
      if (was) was.textContent = t.full > t.now ? money(t.full) : '';
      var mine = card.querySelector('[data-mine]');
      if (mine) mine.textContent = 'Yours: ' + root.dataset.mainTitle + (mv.info.name && mv.info.name !== 'Default Title' ? ', ' + mv.info.name : '') + '. Change it up top.';
    });
    picks.forEach(renderPick);
    document.dispatchEvent(new CustomEvent('slp:bundle', { detail: { total: total(selected()).now, set: current > 0 } }));
  }

  root.addEventListener('change', function (e) {
    if (e.target.name !== 'slp-bundle') return;
    current = +e.target.value;
    root.classList.remove('is-error');
    cards.forEach(function (c) { c.classList.remove('is-need'); });
    render();
  });
  root.addEventListener('click', function (e) {
    var pr = e.target.closest('.slp-b__print');
    if (pr && !pr.disabled) {
      var pq = picks.filter(function (x) { return x.el === pr.closest('[data-partner]'); })[0];
      if (pq) {
        choosePrint(pq, +pr.dataset.print);
        if (cards.indexOf(pq.card) !== current) { current = cards.indexOf(pq.card); pq.card.querySelector('input').checked = true; }
        render();
        var again = pq.el.querySelector('[data-print="' + pr.dataset.print + '"]'); if (again) again.focus();
      }
      return;
    }
    var b = e.target.closest('.slp-b__size');
    if (!b || b.disabled) return;
    var pEl = b.closest('[data-partner]');
    var p = picks.filter(function (x) { return x.el === pEl; })[0];
    if (!p) return;
    var i = +b.dataset.opt;
    p.sel[i] = b.dataset.val;
    // a colour change can make the picked size unavailable; drop it so the shopper picks again
    p.data.options.forEach(function (name, k) { if (k !== i && p.sel[k] && !inStock(p, k, p.sel[k])) delete p.sel[k]; });
    if (cards.indexOf(p.card) !== current) { current = cards.indexOf(p.card); p.card.querySelector('input').checked = true; }
    if (!missing(p.card).length) { root.classList.remove('is-error'); p.card.classList.remove('is-need'); }
    render();
  });
  // the theme's size picker changes the main variant: re-price after it has run
  form.addEventListener('click', function (e) { if (!root.contains(e.target)) setTimeout(render, 60); });
  form.addEventListener('change', function (e) { if (!root.contains(e.target)) setTimeout(render, 60); });

  function missing(card) { return (card.partners || []).filter(function (p) { return !chosen(p); }); }

  // ---- add to bag ----
  function openMiniCart() {
    var tries = 0;
    (function open() {
      var cart = window.PROJ && window.PROJ.ajaxcart;
      if (cart && cart.updateCart && cart.opencart) { cart.updateCart(); cart.opencart(); }
      else if (++tries < 20) setTimeout(open, 100);
      else location.href = '/cart';
    })();
    if (typeof window.addedToCartKlaviyo === 'function') { try { window.addedToCartKlaviyo(); } catch (e) {} }
  }
  var busy = false;
  document.addEventListener('submit', function (e) {
    if (e.target !== form || current === 0) return; // "Just this one": the theme adds it as before
    e.preventDefault(); e.stopImmediatePropagation();
    var card = selected(), need = missing(card);
    if (need.length) {
      card.classList.add('is-need'); root.classList.add('is-error');
      card.querySelector('.slp-b__msg').textContent = 'Pick a size for ' + who(need[0]) + ' first.';
      render();
      var target = need[0].el;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.classList.remove('slp-flash'); void target.offsetWidth; target.classList.add('slp-flash');
      return;
    }
    var mv = mainVariant();
    if (!mv.id || busy) return;
    var tag = card.dataset.title || 'Set';
    var items = [{ id: mv.id, quantity: +card.dataset.qty || 1, properties: { _bundle: tag } }];
    card.partners.forEach(function (p) { items.push({ id: chosen(p).id, quantity: 1, properties: { _bundle: tag } }); });
    busy = true;
    var btn = form.querySelector('button[name="add"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (er) { throw new Error(er.description || er.message || 'Could not add'); }); return r.json(); })
      .then(openMiniCart)
      .catch(function (er) { root.classList.add('is-error'); card.querySelector('.slp-b__msg') ? card.querySelector('.slp-b__msg').textContent = er.message : alert(er.message); })
      .then(function () { busy = false; if (btn) btn.removeAttribute('aria-busy'); });
  }, true);

  render();
})();
